import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  DeleteTaskManagerItemDocument,
  type DeleteTaskManagerItemMutationVariables,
} from '@/graphql/generated/graphql';

export type DeleteTaskManagerItemVariables = DeleteTaskManagerItemMutationVariables;

export const useDeleteTaskManagerItem = () => {
  const mutation = useMutation({
    mutationKey: ['delete-task-manager-item'],
    mutationFn: (variables: DeleteTaskManagerItemMutationVariables) =>
      graphqlClient.request(DeleteTaskManagerItemDocument, variables),
  });

  return {
    ...mutation,
    deleteTaskManagerItem: mutation.mutate,
    deleteTaskManagerItemAsync: mutation.mutateAsync,
  };
};

export const DELETE_TASK_MANAGER_ITEM_MUTATION = DeleteTaskManagerItemDocument;
